import type { JSX } from 'react';
import type { IconProps } from '@solidops/ui/icon';
import { BuildingIcon } from './BuildingIcon.js';
import { CalendarDaysIcon } from './CalendarDaysIcon.js';
import { FileTextIcon } from './FileTextIcon.js';
import { MailIcon } from './MailIcon.js';
import { SlidersIcon } from './SlidersIcon.js';
import { UsersIcon } from './UsersIcon.js';

const icons: Record<string, typeof UsersIcon> = {
  Schedules: CalendarDaysIcon,
  Members: UsersIcon,
  Settings: SlidersIcon,
  'Contact methods': MailIcon,
  'Users and roles': UsersIcon,
  Customers: BuildingIcon,
};
export function NavigationIcon({
  name,
  ...props
}: IconProps & { readonly name: string }): JSX.Element {
  const Icon = icons[name] ?? FileTextIcon;
  return <Icon {...props} />;
}
